<template lang="pug">
    .row
        .col-9.col-sm-9.col-md-9.message-wrapper(v-if="!item.link")
            span.message {{item.message}}
        .col-9.col-sm-9.col-md-9.message-wrapper(v-if="item.link")
            a(:href="item.link", target="_blank")
                span.message {{item.message}}
        .col-3.col-sm-3.col-md-3.message-wrapper
            span.date {{item.creation_date}}

</template>

<script>

export default {
    name: 'Announcement',
    props: ["item"],
    created() {
        console.log(this.item);
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";

.message-wrapper {
    padding: $gutter 0;
    font-size: 0.9em;
}

.date {
    font-weight: 300;
    font-size: 0.85em;
    display: inline-block;
    padding-right: $gutter*2;
    float:right;
}
</style>




// WEBPACK FOOTER //
// src/components/dashboard/Announcement.vue